import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslatePipe } from '../../shared/i18n/translate.pipe';
import { ConsentService } from '../../shared/services/consent.service';

@Component({
    selector: 'app-simple-layout',
    templateUrl: './simple-layout.component.html',
    styleUrls: ['./simple-layout.component.css'],
    standalone: true,
    imports: [RouterLink, RouterOutlet, TranslatePipe]
})
export class SimpleLayoutComponent implements OnInit {
  version = '';
  copyright = '';

  constructor(private consent: ConsentService) { }

  ngOnInit(): void {
    this.version = environment.version;
    this.copyright = environment.copyright;
  }

  /** Link w stopce - baner zgody z aktualnym wyborem, do zmiany w kazdej chwili. */
  openConsent(): void {
    this.consent.open();
  }

}
